<template>
  <div class="pd-top-15">
    <v-container fluid>
      <v-breadcrumbs
        class="fadeIn breadcrumb"
        :items="breadcrumbItems">
        <v-icon slot="divider">chevron_right</v-icon>
      </v-breadcrumbs>

      <v-layout md12 justify-center v-if="!rolCliente">
        <v-btn class="ml-1 mr-1" @click="goToLista()" color="primary ">
          {{localization.buttons.listaSolicitudes}}
        </v-btn>
        <v-btn class="ml-1 mr-1" @click="goToVisitId(incidencia.visitaId)" color="primary " v-if="!rolProveedor">
          {{localization.buttons.irVisita}}
        </v-btn>
        <!-- <v-btn class="ml-1 mr-1" color="primary" :disabled="!permiteEnviarParte" @click="openEnviarParte(incidencia)">
          {{localization.buttons.enviarParte}}
        </v-btn> -->
        <v-btn
          class="ml-1 mr-1" color="primary"
          :disabled="incidencia.codigoTipoSolicitud !== '1'"
          @click="clickEnviarParte(incidencia)">
          {{localization.buttons.enviarParte}}
        </v-btn>
      </v-layout>
      <v-layout md12 justify-center v-if="rolCliente && (getConfiguracion.clientesCerrarWeb == true || getConfiguracion.clientesRechazarWeb == true)">
        <v-btn class="ml-1 mr-1" :disabled="!(((incidencia.codigoEstado == 30 && getConfiguracion.desdeTerminadoWeb) || (incidencia.codigoEstado == 41 && getConfiguracion.configVistoBuenoClienteWeb)) && getConfiguracion.clientesCerrarWeb)" color="primary" @click="setNuevoEstadoRolCliente(incidencia, 50)"><v-icon left dark>check</v-icon>Cerrar</v-btn>
        <v-btn class="ml-1 mr-1" :disabled="!(((incidencia.codigoEstado == 30 && getConfiguracion.desdeTerminadoWeb) || (incidencia.codigoEstado == 41 && getConfiguracion.configVistoBuenoClienteWeb)) && getConfiguracion.clientesRechazarWeb)" color="primary" @click="setNuevoEstadoRolCliente(incidencia, 90)"><v-icon left dark>close</v-icon>Rechazar</v-btn>
      </v-layout>
      <FormEnviarParte :incidenceIds="incidenciaParte" v-model="dialogEnviarParte" id="dialogEnviarParte" @msgSuccessEnviarParte="addSuccessMsgEnviarParte()"/>
      <v-layout wrap pt-3>
        <v-flex md12>
          <v-tabs centered :vertical="windowWidth > 1024 ? true : false" background-color="transparent" class="transparentTabs"  v-model="active_tab" id="active_tab">
              <v-tab v-for="(item, i) in tabItems"
              :key="i + '-tab'">
                <v-row justify="center" align="center">
                  {{ item.name }}
                </v-row>
              </v-tab>
              <v-btn color="primary" @click="saveIncidencia()" :disabled="!cambiadoAlert" v-if="!rolCliente && (!rolProveedor || rolProveedor && permisosExtraProveedor() )">
                {{localization.buttonGuardar}}
              </v-btn>
              <v-label v-else>&nbsp;</v-label>
              <v-tab-item v-for="(item, i) in tabItems"
              :key="i + '-tab'">
                <v-container fluid class="pt-0">
                  <component
                    :ref="'componente' + i"
                    :is="item.tipo"
                    :incidencia.sync="incidencia"
                    :cambiado="cambiado[i]"
                    @cambiado="updateCambiado($event, i)"
                    @cambioEstado="cambioEstado($event)"
                    @recargarIncidencia="recargarIncidencia()"
                    @validar="valid = $event"
                  />
                </v-container>
              </v-tab-item>
            </v-tabs>
        </v-flex>
        <ConfirmDialog :text="$t('deseaContinuar')"
           @cancel="dialogParte = false" :dialogFlag="dialogParte" @close="openEnviarParte(incidencia)"
           :textoBoton="textoAceptarDialogParte" :textoTitulo="textoTituloDialogParte" />
        <ConfirmDialog @close="confirmarCrearProveedor()" :text="textoConfirmacion"
          @cancel="dialogConfirmacion = false" :dialogFlag="dialogConfirmacion"
          :textoBoton="textoAceptar" :textoTitulo="textoTituloConfirmacion" />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DatosIncidencia from './detalleIncidencia/datosIncidencia'
import DatosVisita from './detalleIncidencia/datosVisita'
import Evolucion from './detalleIncidencia/evolucion'
import Documentacion from './detalleIncidencia/documentacion'
import FormEnviarParte from './formularios/formEnviarParte'
import alertBeforeExit from '@/mixins/alertBeforeExit'
import ConfirmDialog from '../custom/confirmDialog'

import chat from '@/components/chat/ChatMin'

// import moment from 'moment'
// import _ from 'lodash'

export default {
  mixins: [alertBeforeExit],
  components: {
    DatosIncidencia,
    DatosVisita,
    Evolucion,
    Documentacion,
    FormEnviarParte,
    chat,
    ConfirmDialog
  },
  props: ['idIncidencia', 'filters'],
  beforeCreate () {
    document.documentElement.classList.add('showScrollbar2')
  },
  created () {
    this.inicializar()
    // reiniciamos el canal para que recargue el chat
    this.$store.commit('chat/resetCanal')
    this.$store.commit('chat/resetHistory')
  },
  data () {
    return {
      valid: true,
      cambiado: [false, false, false, false],
      cambiadoProveedor: false,
      incidenciaParte: [],
      dialogEnviarParte: false,
      loadedAll: false,
      oldCodigoTipoSolicitud: '1',
      incidencia: {},
      datosNuevoEstado: null,
      guardado: false,
      permiteEnviarParte: false,
      breadcrumbItems: [],
      textoConfirmacion: this.$t('verIncidencia').dialogConfirmacion.textoConfirmarActorProveedor,
      dialogConfirmacion: false,
      dialogParte: false,
      textoTituloConfirmacion: this.$t('verIncidencia').dialogConfirmacion.titulo,
      textoAceptar: this.$t('verIncidencia').dialogConfirmacion.boton,
      textoAceptarDialogParte: this.$t('verIncidencia').dialogConfirmacion.boton,
      windowWidth: 0,
      active_tab: 0
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    this.breadcrumbItems = [
        {
        text: this.$t('navDrawer.home').toUpperCase(),
        disabled: false,
        to: {name: 'home'},
        exact: true
      },
      {
        text: this.$t('incidencias').toUpperCase(),
        disabled: false,
        to: this.rolCliente ? {name: 'solicitudesRolCliente', params: {filters: this.filters}} : {name: 'incidencias', params: {filters: this.filters}},
        // codigoTipo: this.vengoDeUrlConTipoSolicitud,
        exact: true
      },
      {
        text: this.localization.breadcrumb,
        disabled: true
      }
    ]
  },
  methods: {
    updateCambiado (val, index) {
      this.cambiado[index] = val
      this.cambiadoAlert = this.cambiado.includes(true)
      if (index == 0 && !val) {
        this.cambiadoProveedor = false
      }
    },
    goToLista () {
      if (this.rolCliente === true) {
        this.$router.go(-1)
      } else {
        if (parseInt(this.vengoDeUrlConTipoSolicitud) > 0) {
          this.$router.push({ name: 'incidencias', params: {codigoTipo: this.vengoDeUrlConTipoSolicitud, filters: this.filters} })
        }else {
          this.$router.push({ name: 'incidencias', params: {filters: this.filters} })
        }
      }
    },
    cambioEstado (val) {
      this.datosNuevoEstado = val
    },
    async setNuevoEstadoRolCliente (incidencia, codigoEstado) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });

        // Estado
        let nuevoEstado = this.getEstados.find(x => x.code === codigoEstado.toString())

        let values = [{
          incidenceId: [incidencia.id],
          statusId: nuevoEstado.id,
          updateDate: new Date().toISOString().substr(0, 10),
          updateDescription: "Estado modificado por cliente",
          vb: "0"
        }];

        await this.updateIncidenceStatus(values)
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
        this.loader.hide()
        this.$router.go()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    clickEnviarParte (incidencia) {
      if (this.cambiadoProveedor) {
        this.addAlert({texto: this.$t('cambiosSinGuardarSolicitud'), color: 'error'})
      } else if (!this.permiteEnviarParte) {
        this.dialogParte = true
      } else {
        this.openEnviarParte(incidencia)
      }
    },
    permisosExtraProveedor () {
      var codEstadosPermisosExtraProveedor = [10,20]
      if ( this.rolProveedor && this.getConfiguracion.PV_PERMISOS_EXTRA_PROVEEDOR && codEstadosPermisosExtraProveedor.includes(parseInt(this.incidencia.codigoEstado)) ) {
        return true
      }
      return false
    },
    openEnviarParte () {
      this.dialogParte = false
      const objectEdited = {
        id: this.incidencia.id,
        propertyDevelopment: this.incidencia.promocion,
        proveedor: this.incidencia.proveedorId,
        promocion: this.incidencia.promocionId,
        nombrePromocion: this.incidencia.promocion,
        inmueble: this.incidencia.inmuebleId,
        inmuEspe: this.incidencia.inmuebleEspecialPromocionId
      }
      this.incidenciaParte = []
      this.incidenciaParte.push(objectEdited)
      this.dialogEnviarParte = true
      // console.log('OPENING', this.incidenciaParte)
    },
    async saveIncidencia () {
      this.guardado = true
      this.$refs.componente0[0].validar()
      // this.$refs.componente2[0].validar()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        const loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })
        try {
          const incidenciaToUpdate = {
            codigoTipoSolicitud: this.incidencia.codigoTipoSolicitud,
            answerDate: this.incidencia.fechaRespuestaObra,
            approvedAmount: this.incidencia.costeAprobado,
            complaint: this.incidencia.complaint,
            contact: null,
            crearActorRolProveedor: false,
            declinedAmount: this.incidencia.costeRechazado,
            description: this.incidencia.descripcion,
            estimatedAmount: this.incidencia.costeEstimado,
            fechaReapertura: this.incidencia.fechaReapertura,
            finishDateNotification: this.incidencia.fechaNotificacionFinPrevisto,
            hours: this.incidencia.horas ? this.incidencia.horas : null,
            id: this.incidencia.id,
            initialFinishDate: this.incidencia.fechaFinPrevisto,
            invoiced: this.incidencia.facturado, // facturado
            notificationDate: this.incidencia.fechaAviso,
            obs: this.incidencia.observaciones,
            orderTypeId: this.incidencia.tipoParteId,
            predefinedIncidenceId: this.incidencia.incidenciaPredefinidaId,
            proffesion2Id: this.incidencia.suboficioId,
            proffesionId: this.incidencia.oficioId,
            providerId: this.incidencia.proveedorId,
            reabierta: this.incidencia.reabierta === true || this.incidencia.reabierta === 1 ? 1 : 0,
            realAmount: this.incidencia.costeReal,
            realFinishDate: this.incidencia.fechaFinReal,
            realFinishDateNotification: this.incidencia.fechaNotificacionFinReal,
            recidivist: this.incidencia.reincidente === true || this.incidencia.reincidente == 1 ? 1 : 0,
            refuseDateNotification: this.incidencia.fechaNotificacionRechazo,
            responsableId: this.incidencia.responsableId,
            roomId: this.incidencia.estanciaId,
            severityId: this.incidencia.urgenciaId,
            visitId: this.incidencia.visitaId,
            revisada: this.incidencia.Revisada === true || this.incidencia.Revisada === 1 ? 1 : 0,
            fechaRevision: this.incidencia.fechaRevision,
            evaluado: this.incidencia.evaluado
          }
          /*if (this.datosNuevoEstado) {
            await this.updateIncidenceStatus(this.datosNuevoEstado)
          }*/
          await this.updateIncidencia(incidenciaToUpdate)
          //preguntamos por rol proveedor

          if (this.$refs.componente2) {
            await this.$refs.componente2[0].recargar()
          }
          this.cambiadoAlert = false
          loader.hide()
          await this.inicializar()
          var proveedorSeleccionado = this.getProvidersByPropDevAndProf.find(x => x.id === this.incidencia.proveedorId )
          // tiene activo el crear actor en modificacion de incidencias
          if(this.getConfiguracion.PV_ALTA_ACTOR_PROVEEDOR && this.idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 0) {
            if(this.idubapi.rolProveedor && incidenciaToUpdate.providerId != '' && incidenciaToUpdate.providerId != null && (proveedorSeleccionado.id_actor === null || proveedorSeleccionado.id_actor === undefined)) {
              //rol proveedor
              this.dialogConfirmacion = true
            }
          }
          
          this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
        } catch (error) {
          this.guardado = false
          this.addAlert({ texto: this.$t('errorGuardarDatos') + error, color: 'error' })
        }
      }
    },
    ...mapActions({
      addAlert: 'alerts/add',
      getIncidencia: 'incidencias/getIncidencia',
      wsOficios: 'incidencias/getOficios',
      wsSuboficios: 'incidencias/getSuboficios',
      updateIncidencia: 'incidencias/updateIncidencia',
      updateIncidenceStatus: 'incidencias/updateIncidenceStatus',
      getComplaintTypesByIncidence: 'incidencias/getComplaintTypesByIncidence',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',
      crearActorAsociadoRolProveedor: 'incidencias/crearActorAsociadoRolProveedor'
    }),
    goToVisitId (id) {
      this.$router.push({
        name: 'datosVisita',
        params: { actualVisitId: id }
      })
    },
    async recargarIncidencia () {
      this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        })
      await this.getIncidencia(this.idIncidencia)
        // Se crea un objeto nuevo
      this.incidencia = Object.assign({}, this.getIncidenciaById, {complaint: null})
      this.loader.hide()
      
    },
    async inicializar () {
      const loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      try {
        await this.getIncidencia(this.idIncidencia)

        if(this.$route.query.chat) {
          let chat = this.$route.query.chat
          if(chat == 1) {
            let chatTab = this.tabItems.findIndex(item => item.ref === 'chat')
            this.active_tab = chatTab
          }
        }
        // Se crea un objeto nuevo
        this.incidencia = Object.assign({}, this.getIncidenciaById, {complaint: null})

        this.permiteEnviarParte = (this.incidencia.proveedorId !== null)


        await this.$nextTick()
        this.oldCodigoTipoSolicitud = this.incidencia.codigoTipoSolicitud
        this.cambiado = [false, false, false, false]
        this.cambiadoAlert = false
        this.cambiadoProveedor = false
        // this.loadedAll = true
        loader.hide()

      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          loader.hide()
        }
      }
    },
    async confirmarCrearProveedor() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        await this.crearActorAsociadoRolProveedor(this.incidencia.proveedorId)
        this.loader.hide()
        this.dialogConfirmacion = false
        this.addAlert({texto: 'Acceso a la App concedido correctamente', color: 'success'})
      } catch (error) {
        this.loader.hide()
        this.dialogConfirmacion = false
        this.addAlert({texto: error.message, color: 'error'})
      }



    },
    async addSuccessMsgEnviarParte () {
      try {
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })
        const items = {
          professionId: this.incidencia.oficioId,
          propertyDevelopmentId: this.incidencia.promocionId
        }
        await this.getProvidersByPropertyDevAndProfession(items)
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        loader.hide()
      }
      let proveedorSeleccionado = this.getProvidersByPropDevAndProf.find(x => x.id === this.incidencia.proveedorId)
      await this.$nextTick()
      proveedorSeleccionado = this.getProvidersByPropDevAndProf.find(x => x.id === this.incidencia.proveedorId)
      loader.hide()

      if (this.incidencia.proveedorId === null || this.incidencia.proveedorId === undefined) {
        this.textMsgEnviarParteSuccess = this.$t('parteGenerado')
      } else if ((proveedorSeleccionado !== undefined && proveedorSeleccionado !== null) && (proveedorSeleccionado.email === '' || proveedorSeleccionado.email === null)) {
        this.textMsgEnviarParteSuccess = this.$t('parteGeneradoNoEnviado')
      } else {
        this.textMsgEnviarParteSuccess = this.$t('partesGeneradoYEnviado')
      }
      this.addAlert({ texto: this.textMsgEnviarParteSuccess, color: 'success' })
      //recargamos los documentos
      if(this.$refs.componente3) // validamos que se haya cargado previamente
        this.$refs.componente3[0].getAllImages()
    }
  },
  computed: {
    ...mapGetters({
      getIncidenciaById: 'incidencias/getById',
      getterComplaintTypesByIncidence: 'incidencias/getComplaintTypesByIncidence',
      idubapi: 'login/idubapi',
      getProvidersByPropDevAndProf: 'incidencias/getProvidersByPropDevAndProf',
      getConfiguracion: 'configuracion/getConfiguracion',
      getEstados: 'incidencias/getStatusTypes',
      rolProveedor: 'login/rolProveedor'
    }),
    vengoDeUrlConTipoSolicitud () {
      return this.$store.state.incidencias.navCodTipoSolicitud
    },
    textoTituloDialogParte () {
      return this.$t('incidenciaSinProveedor')
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    localization () {
      return this.$t('verIncidencia')
    },
    tabItems () {
      if (this.rolCliente === true) {
        let evolucion = []
        if(this.getConfiguracion.mostrarObservacionesWeb) {
          evolucion = [
            {
              name: this.localization.tabs.evolucion,
              link: '/evolucion',
              tipo: 'Evolucion'
            }
          ]
        }

        return [
          {
            name: this.localization.tabs.datosSolicitud,
            link: '/datos-incidencia',
            tipo: 'DatosIncidencia'
          },
          {
            name: this.localization.tabs.datosVisita,
            link: '/datos-visita',
            tipo: 'DatosVisita'
          },
          {
            name: this.localization.tabs.documentacion,
            link: '/documentacion',
            tipo: 'Documentacion'
          },
          ...evolucion
        ]
      } else if (this.rolProveedor) {
           return [
          {
            name: this.localization.tabs.datosSolicitud,
            link: '/datos-incidencia',
            tipo: 'DatosIncidencia'
          },
          {
            name: this.localization.tabs.datosVisita,
            link: '/datos-visita',
            tipo: 'DatosVisita'
          },
          {
            name: this.localization.tabs.evolucion,
            link: '/evolucion',
            tipo: 'Evolucion'
          },
          {
            name: this.localization.tabs.documentacion,
            link: '/documentacion',
            tipo: 'Documentacion'
          }
        ]
      } else {
        let items = [
          {
            name: this.localization.tabs.datosSolicitud,
            link: '/datos-incidencia',
            tipo: 'DatosIncidencia'
          },
          {
            name: this.localization.tabs.datosVisita,
            link: '/datos-visita',
            tipo: 'DatosVisita'
          },
          {
            name: this.localization.tabs.evolucion,
            link: '/evolucion',
            tipo: 'Evolucion'
          },
          {
            name: this.localization.tabs.documentacion,
            link: '/documentacion',
            tipo: 'Documentacion'
          }
        ]
        if(this.idubapi.motor !== 'SIN_BD') {
          items.push({
            name: this.localization.tabs.chat,
            link: '/chat',
            tipo: 'chat',
            ref: 'chat'
          })
        }
        return items
      }
    },
    responsables () {
      if (this.$store.state.incidencias.responsables) {
        return this.$store.state.incidencias.responsables
      }
      return []
    },
    orderTypes () {
      if (this.$store.state.incidencias.orderTypes) {
        return this.$store.state.incidencias.orderTypes
      }
      return []
    },
    annotations () {
      if (this.$store.state.incidencias.annotations) {
        return this.$store.state.incidencias.annotations
      }
      return []
    }
  },
  watch: {
    'incidencia.proveedorId': function () {
      this.cambiadoProveedor = true
    }
  },
  destroyed () {
    document.documentElement.classList.remove('showScrollbar2')
  }
}
</script>


<style >
.textField {
  flex-basis: 500px;
  flex-grow: 0;
}

.autoComplete {
  flex-basis: 500px;
  flex-grow: 0;
}

.fila {
  margin-top: 0px;
}

.span {
  width: 150px;
  flex-grow: 0;
}

.changeColor {
  width: 100px;
  padding-right: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
}
select option:disabled {
    color: #CCC;
}
</style>

<style lang="sass">
.checkOtras
  & .material-icons.icon.icon--selection-control
    margin-top: 5px



.labelConfig
  width: 410px
  margin-right: 10px


</style>
